import { BaseService } from './baseService';
import { MedicineDoseDto, medicineDoseFormData } from '../types/medicineDose';

class MedicineDoseService extends BaseService<MedicineDoseDto,typeof medicineDoseFormData> {
    constructor() {
        super('/MedicineDose');
    }
}

export const medicineDoseService = new MedicineDoseService();